<div class="container">
  <div>
    <div class="upload-area">
      <div class="upload-area-content" (click)="triggerUpload()">
        <p class="area-text">Click para subir archivos</p>
        <p class="area-text">Formatos permitidos: JPG, JPEG, PNG, PDF</p>
        <div class="files-uploaded" *ngIf="uploadedFiles.length > 0">
          <span class="text-container" *ngFor="let file of uploadedFiles">
            <span class="area-text">{{ file.name }}</span>
            <img
              *ngIf="!file.uploaded"
              (click)="removeFile(file.name, $event)"
              class="remove-file"
              src="assets/icons/close_violet.svg"
              alt="Remove file"
            />
            <img
              *ngIf="file.uploaded"
              class="file-uploaded"
              src="assets/icons/circular-tick.svg"
              alt="File uploaded"
            />
          </span>
        </div>
      </div>
      <input
        #fileUploadInput
        type="file"
        value=""
        accept="image/*, application/pdf"
        (change)="readFile($event)"
        multiple
      />
    </div>
    <div class="error-upload" *ngIf="uploadError.length > 0">
      <p *ngFor="let error of uploadError">{{ error }}</p>
    </div>
    <div class="upload-button">
      <button
        class="basic-btn"
        [disabled]="
          filesAreUploaded || uploadedFiles.length === 0 || uploadError.length > 0 || loading
        "
        (click)="uploadFiles()"
      >
        {{ loading ? 'SUBIENDO...' : 'SUBIR' }}
      </button>
    </div>
  </div>
</div>
